// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__9WNY+","summary":"AdvancePaymentDetails_summary__BVvhh","edit":"AdvancePaymentDetails_edit__w2kge"};